import { render, staticRenderFns } from "./CommunicationOfferTrade.vue?vue&type=template&id=7efd9766&scoped=true"
import script from "./CommunicationOfferTrade.vue?vue&type=script&lang=js"
export * from "./CommunicationOfferTrade.vue?vue&type=script&lang=js"
import style0 from "./CommunicationOfferTrade.vue?vue&type=style&index=0&id=7efd9766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efd9766",
  null
  
)

export default component.exports